import { Progress } from "antd";
import React, { useRef, useState } from "react";
import play_btn from "../../assets/img/play_btn.png";
import thumbnail from "../../assets/img/thumbnel.png";
import video from "../../assets/video/video.mp4";
import CustomSelector from "../selector/CustomSelector";

export default function FundingDebtRelief() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleTogglePlay = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleSelectChange = (option) => {
    console.log(option);
  };

  const options = [
    { value: "1", label: "$0 - $4,999" },
    { value: "2", label: "$5,000 - $24,999" },
    { value: "3", label: "$25,000 - $99,999" },
  ];

  return (
    <div className="funding_overview mt-3 progress_page">
      <div className="funding_common_area">
        <div className="content">
          <h3>
            Debt Relief: Combine All Debts into a Single Loan, Lower Utilization
          </h3>
          <div className="video-container relative mt-3">
            <video
              ref={videoRef}
              src={video}
              className="video"
              onClick={handleTogglePlay}
              preload="metadata"
            />
            {/* Thumbnail overlay */}
            {!isPlaying && (
              <div className="thumbnail-overlay flex justify-center items-center">
                <img
                  src={thumbnail}
                  alt="Video Thumbnail"
                  className="thumbnail"
                />
                <div className="play-button" onClick={handleTogglePlay}>
                  <img className="icons" src={play_btn} alt="" />
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="card">
          <Progress
            percent={25}
            percentPosition={{ align: "end", type: "inner" }}
            size={[300, 20]}
            strokeColor="#001342"
            className="ant_progress_bar"
          />
          <div className="mt-4 text-center">
            <h3>Select Your Debt Amount</h3>
            <p className="mt-2">
              Debt relief consolidates multiple debts into a single loan,
              reducing utilization and simplifying payments.
            </p>
          </div>
          <div className="my-3">
            <CustomSelector
              options={options}
              onSelect={handleSelectChange}
              selectedText="Select Your Debt Amount"
            />
          </div>
          <button className="btn">Next</button>
        </div>
      </div>
    </div>
  );
}
